/**
 * Maps runtime organization identifier to admin panel family for normalizers.
 *
 * Foodna (stagingfoodna / foodna hosts): lofat, ghadhana — same response shapes.
 * Console (console / staging dietmaster): testing, staging, and other non-foodna slugs.
 */
import { environment } from '../../../shared/config/environment';

export type ApiPanel = 'foodna' | 'console';

const FOODNA_IDENTIFIERS = new Set(['lofat', 'ghadhana']);

export function resolveApiPanel(identifier: string): ApiPanel {
  if (FOODNA_IDENTIFIERS.has(identifier)) {
    return 'foodna';
  }
  return 'console';
}

/** Runtime panel from white-label identifier (environment / dev hub target). */
export function resolveCurrentApiPanel(): ApiPanel {
  return resolveApiPanel(environment.IDENTIFIER);
}
